import type { GridApi } from "ag-grid-community";

// Deliberately a zero-dependency leaf module (the ag-grid import is type-only):
// it is imported by tradeCreationHelper and AGGridNoRowsOverlay, and any runtime
// import here risks re-entering the widget module cycles (see CLAUDE.md).

// Robustly clear every column filter on a grid.
// `setFilterModel(null)` alone can leave a *statically-provided* Set Filter's
// applied keys out of sync with its (now-null) model, so the rows stay
// filtered after a normal clear (Direction is the only such filter, its
// filterParams.values is a hardcoded list). Destroying each filter instance
// forces a fresh, unfiltered state regardless of how the filter was configured.
// A Set Filter restored before rows exist drops every value it can't find yet,
// so callers hold a saved filter model until this is true.
export function gridHasLeafRows(api: GridApi): boolean {
  let hasRows = false;
  api.forEachLeafNode(() => {
    hasRows = true;
  });
  return hasRows;
}

export function clearAllGridFilters(api: GridApi) {
  if (!api) return;
  api.setFilterModel(null);
  api.getColumns()?.forEach((col) => api.destroyFilter(col.getColId()));
  api.onFilterChanged();
}
